import React from 'react';

import { Container } from './styles';

const PageContainer: React.FC = ({ children, ...rest }) => {
  return <Container {...rest}>{children}</Container>;
};

export default PageContainer;
